import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { getCellularAttenuationRows, MAX_CELLULAR_SECTIONS } from "../../../utils/stormBuildUpCellularAttenuation";
import { COLORS } from "../../../utils/constants";

type CellularAttenuationTableProps = Omit<StormBuildUpTableProps, 'rows' | 'onDeleteSection' | 'onConfigureSection'> & {
  sectionCount: number;
  supplierName?: string;
  sectionTitles?: Record<string, string>;
  onAddTank: () => void;
  onDeleteSection: (headerId: string) => void;
  onConfigureSection: (headerId: string) => void;
  crateDims?: Record<string, number>;
};

export default function CellularAttenuationTable({ sectionCount, supplierName, sectionTitles, onAddTank, onDeleteSection, onConfigureSection, crateDims, ...props }: CellularAttenuationTableProps) {
  return (
    <div>
      <StormBuildUpTable rows={getCellularAttenuationRows(sectionCount, supplierName, crateDims, sectionTitles)} onDeleteSection={onDeleteSection} onConfigureSection={onConfigureSection} {...props} />
      <div style={{ marginTop: '16px' }}>
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: COLORS.primary }} />}
          onClick={onAddTank}
          disabled={sectionCount >= MAX_CELLULAR_SECTIONS}
          style={{ color: COLORS.primary, fontWeight: 500, padding: '4px 8px' }}
        >
          Add New Tank
        </Button>
      </div>
    </div>
  );
}
